import { UseWalletClientReturnType, useAccount, useConnectorClient, useWalletClient, useSwitchChain } from "wagmi";

import { useEthersSigner } from "./useEthersSigner";

export type WalletClient = UseWalletClientReturnType["data"];

export default function useWallet() {
  const { address, isConnected, connector, chainId } = useAccount();
  const { data: connectorClient } = useConnectorClient();
  const { data: walletClient } = useWalletClient();
  const { switchChain } = useSwitchChain();

  const signer = useEthersSigner();
  // add switch network

  return {
    account: address,
    active: isConnected,
    connector: connector!,
    chainId: chainId,
    signer: signer,
    connectorClient,
    walletClient,
    switchChain,
  };
}
